module.exports = __webpack_public_path__ + "img/4.7f0dc7f0.png";